import { Model } from 'app/model/backendmodel';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { Named, Owned } from 'app/model/base/named';
import { FileLocationAdapter } from './file-location.adapter';
import { HdfsLocation } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(HdfsLocation)
})
export class HdfsLocationAdapter extends FileLocationAdapter<HdfsLocation, Model.DatasetLocation> {
    public _toResource(store: HdfsLocation): Model.HdfsLocation {
        const resource: Model.HdfsLocation = {
            type: 'HdfsLocation',
            fileName: ValueAdapter.toResource(store, HdfsLocation.FILE_NAME) || undefined,
            folderPath: ValueAdapter.toResource(store, HdfsLocation.FOLDER_PATH) || undefined
        };
        return resource;
    }

    public _toModel(resource: Model.HdfsLocation, owner: Named): HdfsLocation {
        const model = Owned.create<HdfsLocation>(HdfsLocation.MODEL, owner);
        ValueAdapter.toModel(model, HdfsLocation.FILE_NAME, resource.fileName);
        ValueAdapter.toModel(model, HdfsLocation.FOLDER_PATH, resource.folderPath);
        return model;
    }
}
